export default __webpack_public_path__ + "static/media/480_business04-fr-mobile.881972b3.png";